<p>player-goals works!</p>
